import * as React from 'react'


export default class Header extends React.PureComponent<{
  savedNames: string[]
  onClickSaved: () => void
  onClickAbout: () => void
  onClickSettings: () => void
}, {}> {
  render() {
    return (
      <div className="header">
        <div className="header-left">
          <div className="header-logo">NameQL</div>
        </div>

        <div className="header-right">
          {/* <div className="header-action" onClick={this.props.onClickSettings}>Settings</div> */}
          <div className="header-action header-action-resources">
            Resources
            <div className="header-action-resources-dropdown">
              <ul>
                <li><a href="https://www.designbombs.com/how-to-make-a-website/" target="_blank">How to make a website</a></li>
                <li><a href="https://www.designbombs.com/how-to-start-a-blog/" target="_blank">How to start a blog</a></li>
                <li><a href="https://www.designbombs.com/best-wordpress-hosting" target="_blank">How to Choose the<br />Best WordPress Hosting</a></li>
                <li><a href="https://www.designbombs.com/website-builders/" target="_blank">Best Website Builders</a></li>
                <li><a href="https://www.designbombs.com/the-best-podcast-hosting-services/" target="_blank">Best Podcast Hosting</a></li>
              </ul>
            </div>
          </div>
          <div className="header-action" onClick={this.props.onClickSaved}>Saved <span>({this.props.savedNames.length})</span></div>
          <div className="header-action" onClick={this.props.onClickAbout}>About</div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/comp/header.tsx